export default {
  updateAccessToken(state, access_token) {
    state.access_token = access_token;
  },
  updateRefreshToken(state, refresh_token) {
    state.refresh_token = refresh_token;
  },
  updateUserInfo(state, user_info) {
    state.user_info = user_info;
  },
  updateLanguagePreference(state, language_preference){
    state.language_preference = language_preference;
  },
  updatePermissions(state, permissions) {
    state.permissions = permissions;
  },
  updatePermissionsPromise(state, permissions_promise) {
    state.permissions_promise = permissions_promise;
  },
  updateProgramCodeInfo(state, program_code) {
    state.program_code = program_code;
  },
  setLoading(state, value) {
    state.isLoading = value;
  },
}
